import { render, staticRenderFns } from "./HowToChooseModal.vue?vue&type=template&id=0c1224d6"
import script from "./HowToChooseModal.vue?vue&type=script&lang=js"
export * from "./HowToChooseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports